module.exports = __webpack_public_path__ + "img/image-gallery-milkbottles.73526a5a.jpg";